import { useMemo } from "react";

const Bat = ({ style, delay }) => (
    <svg
        className="animate-bat absolute opacity-40"
        style={{ ...style, animationDelay: delay }}
        width="42"
        height="20"
        viewBox="0 0 42 20"
        fill="#9D00FF"
        aria-hidden="true"
    >
        <path d="M21 6c-2-3-6-4-9-3-3-2-8-1-12 2 4 0 6 2 8 5 2-2 5-2 7 0 1 2 3 4 6 4s5-2 6-4c2-2 5-2 7 0 2-3 4-5 8-5-4-3-9-4-12-2-3-1-7 0-9 3z" />
    </svg>
);

export const FloatingSpook = () => {
    const embers = useMemo(
        () =>
            Array.from({ length: 18 }, (_, i) => ({
                left: `${(i * 37 + 11) % 100}%`,
                size: 3 + ((i * 7) % 5),
                duration: 9 + ((i * 13) % 10),
                delay: -((i * 2.3) % 12),
                color: i % 3 === 0 ? "#00FF87" : "#FF6B00",
            })),
        [],
    );
    return (
        <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true">
            {embers.map((e, i) => (
                <span
                    key={i}
                    className="ember"
                    style={{
                        left: e.left,
                        width: e.size,
                        height: e.size,
                        background: e.color,
                        boxShadow: `0 0 ${e.size * 3}px ${e.color}`,
                        animationDuration: `${e.duration}s`,
                        animationDelay: `${e.delay}s`,
                    }}
                />
            ))}
            <Bat style={{ top: "12%", left: "8%" }} delay="0s" />
            <Bat style={{ top: "22%", right: "12%" }} delay="1.4s" />
            <Bat style={{ top: "8%", right: "30%" }} delay="2.6s" />
        </div>
    );
};
